export const updateFrame = (frameTitle, frameBackgroundImage) => ({
  type: 'UPDATE_FRAME',
  frameTitle,
  frameBackgroundImage,
});
